export class SignInForm {
  public constructor(
    public readonly usernameOrEmail: string,
    public readonly password: string,
    public readonly rememberMe: boolean,
  ) {}
}
